import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Box, Overlay, LoaderWrapper, ImageWrapper, Image, ContentWrapper } from './round-icon.styles.js';
import { Loader } from '../loader/loader.js';

var _excluded = ["content", "loading", "size", "disabled", "design", "image"];

var customSizeMap = {
  xxxxl: 'xl',
  xxxl: 'l',
  xxl: 'l'
};

var getLoaderSize = function getLoaderSize(size) {
  return size && size in customSizeMap ? customSizeMap[size] : 'm';
};

var getContent = function getContent(content) {
  if (!content) return null;
  if (typeof content === 'string') return content.slice(0, 1);
  return content;
};

var RoundIcon = function RoundIcon(props) {
  var content = props.content,
      loading = props.loading,
      _props$size = props.size,
      size = _props$size === void 0 ? 'm' : _props$size,
      disabled = props.disabled,
      _props$design = props.design,
      design = _props$design === void 0 ? 'neutral' : _props$design,
      image = props.image,
      attrs = _objectWithoutPropertiesLoose(props, _excluded);

  var shouldRenderOverlay = loading || disabled;
  var shouldRenderContent = content && !image;
  var shouldRenderImage = !!image;
  var isText = typeof content === 'string';
  return /*#__PURE__*/React__default.createElement(Box, _extends({
    size: size,
    design: design,
    loading: loading,
    disabled: disabled,
    "aria-hidden": true
  }, attrs), shouldRenderOverlay && /*#__PURE__*/React__default.createElement(Overlay, {
    hasImage: !!image
  }), loading && /*#__PURE__*/React__default.createElement(LoaderWrapper, null, /*#__PURE__*/React__default.createElement(Loader, {
    design: "primary",
    size: getLoaderSize(size)
  })), shouldRenderImage && /*#__PURE__*/React__default.createElement(ImageWrapper, null, /*#__PURE__*/React__default.createElement(Image, {
    "aria-hidden": true,
    src: image
  })), shouldRenderContent && /*#__PURE__*/React__default.createElement(ContentWrapper, {
    isText: isText,
    disabled: disabled,
    design: design,
    size: size,
    loading: loading
  }, getContent(content)));
};

export { RoundIcon };
